import React from 'react';
import { cn } from '@/lib/utils';

const AGENDA_MAP = {
  Pending: 'bg-status-warn-soft',
  Approved: 'bg-status-success-soft',
  Rejected: 'bg-status-danger-soft',
  'Sedang Berlangsung': 'bg-status-info-soft',
  Selesai: 'bg-status-neutral-soft',
};

const SPPD_MAP = {
  Pending: 'bg-status-warn-soft',
  Approved: 'bg-status-success-soft',
  Rejected: 'bg-status-danger-soft',
  'Belum Berangkat': 'bg-status-neutral-soft',
  'Sedang Dinas': 'bg-status-info-soft',
  Selesai: 'bg-status-success-soft',
};

const URG_MAP = {
  Normal: 'bg-status-neutral-soft',
  Penting: 'bg-status-warn-soft',
  Mendesak: 'bg-status-danger-soft',
};

export function StatusBadge({ status, type = 'agenda', className }) {
  const map = type === 'sppd' ? SPPD_MAP : type === 'urgensi' ? URG_MAP : AGENDA_MAP;
  const cls = map[status] || 'bg-status-neutral-soft';
  return (
    <span
      data-testid="status-badge"
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border border-transparent whitespace-nowrap',
        cls,
        className
      )}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {status || '-'}
    </span>
  );
}
